/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ScrollPage from "../../Components/scrollpageUp";
import "./Collections.css";

function Collections({ navigateWithTransition }) {
  const location = useLocation();

  const containerRef = useRef(null);
  const activeLinkRef = useRef(null);

  const handleNavigate = (path) => {
    navigateWithTransition(path);
  };

  const allowedPaths = [
    "/collections/cuisines",
    "/collections/dressings",
    "/collections/amenagement",
    "/collections/accessoires",
    "/collections/textures",
  ];

  const showPageHead = allowedPaths.includes(location.pathname);

  useEffect(() => {
    if (showPageHead && activeLinkRef.current) {
      activeLinkRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [location.pathname, showPageHead]);

  return (
    <div className="ElemntsGroupPage">
      <ScrollPage />

      {showPageHead && (
        <nav className="PageHead">
          <ul className="PageHeadLink" ref={containerRef}>
            {[
              {
                path: "/collections/cuisines",
                label: "Cuisines",
              },
              {
                path: "/collections/dressings",
                label: "Dressings",
              },
              {
                path: "#",
                label: "Aménagement intérieur",
              },
              {
                path: "#",
                label: "Accessoires & solutions de rangement",
              },
              {
                path: "#",
                label: "Meubles salles de bain et buanderies",
              },
            ].map((item) => {
              const active = location.pathname === item.path;

              return (
                <li key={item.path}>
                  <a
                    ref={active ? activeLinkRef : null}
                    className={active ? "active" : ""}
                    onClick={() => handleNavigate(item.path)}
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      )}

      <Outlet />
    </div>
  );
}

export default Collections;